// extracted by mini-css-extract-plugin
module.exports = {"root":"HomepageMetadata_root__11hRz","byline":"HomepageMetadata_byline__3PGeQ","author":"HomepageMetadata_author__12q0n","datePublished":"HomepageMetadata_datePublished__2fIRv"};